"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function GetStartedCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className={`relative flex items-center justify-center bg-dark-background text-foreground-dark overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    minHeight: "30vh"
  }}>
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/abstract_study_texture.png)"
    }} aria-hidden="true" />

      <div className="relative z-10 text-center px-6 py-12 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight">
          Start Your Child's Journey Today
        </h2>

        <Link to="/ContactPage">
          <Button size="lg" className="btn-primary text-lg px-8 py-4 animate-pulse-gentle motion-reduce:animate-none" style={{
          animation: "pulse-gentle 8s cubic-bezier(0.4, 0, 0.6, 1) infinite"
        }}>
            Book a Free Consultation
          </Button>
        </Link>
      </div>

      <style jsx>{`
        @keyframes pulse-gentle {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.03);
          }
        }
      `}</style>
    </section>;
}